/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { RequestFormStartingPointResponseType } from "api/response";
import { requestFormStartingPoint } from "api/services/common";
import { commonQueryKeys } from "./commonQueryKeys";

type GetRequestStartingPointOptions = {
  options?: UseQueryOptions<RequestFormStartingPointResponseType>;
};

export function useGetRequestStartingPoint(data: GetRequestStartingPointOptions) {
  const { options } = data;
  return useQuery({
    queryKey: commonQueryKeys.useGetRequestStartingPoint,
    queryFn: () => requestFormStartingPoint().then((res) => res.data),
    ...options,
  });
}
